export default "__VITE_ASSET__CgCG0DJV__"